import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import './HelpModal.css'

interface HelpModalProps {
  isOpen: boolean
  onClose: () => void
}

export const HelpModal: React.FC<HelpModalProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation('help')
  const dialogRef = useRef<HTMLDialogElement>(null)

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape') {
      onClose()
    }
  }

  const handleBackdropClick = (e: React.MouseEvent<HTMLDialogElement>) => {
    const rect = dialogRef.current?.getBoundingClientRect()
    if (
      rect &&
      (e.clientX < rect.left ||
        e.clientX > rect.right ||
        e.clientY < rect.top ||
        e.clientY > rect.bottom)
    ) {
      onClose()
    }
  }

  useEffect(() => {
    const dialog = dialogRef.current
    if (!dialog) return

    if (isOpen) {
      dialog.showModal()
      dialog.focus()
    } else {
      dialog.close()
    }
  }, [isOpen])

  return (
    <dialog
      ref={dialogRef}
      className="help-modal"
      onKeyDown={handleKeyDown}
      onClick={handleBackdropClick}
      aria-labelledby="help-modal-title"
    >
      <div className="help-modal-content">
        <div className="help-modal-header">
          <h2 id="help-modal-title" className="help-modal-title">
            {t('title')}
          </h2>
          <button
            className="help-modal-close"
            onClick={onClose}
            aria-label={t('close')}
            type="button"
          >
            ×
          </button>
        </div>

        <div className="help-modal-body">
          <section className="help-section">
            <h3>{t('noContracts.title')}</h3>
            <p>{t('noContracts.message')}</p>
            <p className="help-highlight">{t('noContracts.possibleCause')}</p>
            <p>{t('noContracts.solution')}</p>
          </section>

          <section className="help-section">
            <h3>{t('generalSupport.title')}</h3>
            <p>{t('generalSupport.message')}</p>
            <ul className="help-list">
              <li>{t('generalSupport.updateData')}</li>
              <li>{t('generalSupport.technicalIssues')}</li>
              <li>{t('generalSupport.generalQuestions')}</li>
            </ul>
          </section>

          <div className="help-modal-footer">
            <a
              href={t('contactLink')}
              target="_blank"
              rel="noopener noreferrer"
              className="help-cta-button"
            >
              {t('contactText')}
            </a>
          </div>
        </div>
      </div>
    </dialog>
  )
}

export default HelpModal
